"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerReply = void 0;
var ServerReply = /** @class */ (function () {
    function ServerReply(data, statusCode, headers) {
        if (statusCode === void 0) { statusCode = 200; }
        if (headers === void 0) { headers = { 'content-type': 'application/json' }; }
        this.statusCode = statusCode;
        this.headers = headers;
        this.data = JSON.stringify(data);
        return {
            statusCode: this.statusCode,
            headers: this.headers,
            data: this.data,
        };
    }
    return ServerReply;
}());
exports.ServerReply = ServerReply;
